import {registerLocaleData} from '@angular/common'
import {provideHttpClient, withInterceptors} from '@angular/common/http'

import {ApplicationConfig, inject, provideAppInitializer, provideZoneChangeDetection} from '@angular/core'
import {MAT_FORM_FIELD_DEFAULT_OPTIONS} from '@angular/material/form-field'
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async'
import {provideRouter, withComponentInputBinding, withHashLocation} from '@angular/router'
import {routes} from './app.routes'

import {LOCAL_STORAGE} from './application/app'
import {authInterceptor} from './application/auth.interceptor'
import {responseInterceptor} from './application/response.interceptor'
import {ConfigService} from './services/config.service'

import localeFr from '@angular/common/locales/fr'
registerLocaleData(localeFr)


export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => {
      const localStorage = inject(LOCAL_STORAGE)
      inject(ConfigService).bootstrap(localStorage)
    }),
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes, withHashLocation(), withComponentInputBinding()),
    provideAnimationsAsync(),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {
        floatLabel: 'always',
      }
    },
    {
      provide: LOCAL_STORAGE,
      useFactory: () => localStorage
    },
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        responseInterceptor
      ])
    )
  ]
}
